import CompanyPositionsMultiSelect from './CompanyPositionsMultiSelect';

export default CompanyPositionsMultiSelect;



// WEBPACK FOOTER //
// ./src/client/Components/CompanyPositionsMultiSelect/index.js